// DeviceDetails.js (create in same folder as ScheduleMetaDataForm.js)
import React from 'react';
import { Box, Grid, Typography, Paper, Chip } from '@mui/material';
import DevicesIcon from '@mui/icons-material/Devices';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import BusinessIcon from '@mui/icons-material/Business';

const DeviceDetails = ({ device }) => {
  if (!device) {
    return (
      <Box sx={{ textAlign: 'center', py: 4 }}>
        <Typography color="text.secondary">No device information available</Typography>
      </Box>
    );
  }

  const DetailRow = ({ label, value, icon: Icon }) => (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        py: 1.5,
        borderBottom: '1px solid',
        borderColor: 'divider',
        '&:last-child': { borderBottom: 'none' },
      }}>
      {Icon && <Icon sx={{ color: 'text.secondary', fontSize: 20 }} />}
      <Box sx={{ flex: 1 }}>
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
          {label}
        </Typography>
        <Typography variant="body1" sx={{ fontWeight: 500 }}>
          {value || '—'}
        </Typography>
      </Box>
    </Box>
  );

  return (
    <Box>
      {/* <DetailRow label="Device ID" value={device.id} icon={DevicesIcon} /> */}

      <DetailRow label="Device Name" value={device.name || device.device_name || device.unit_name} />

      <DetailRow label="Device Type" value={device.device_type} />

      <DetailRow label="Building" value={device.building_name} icon={BusinessIcon} />

      <DetailRow label="Floor" value={device.floor_number} />

      <DetailRow label="Area" value={device.area_name} icon={LocationOnIcon} />

    </Box>
  );
};

export default DeviceDetails;
